import type { AppNotificationType } from './app-notification';
import { AppNotification } from './app-notification';

export type AppNotificationFeedItem = {
  id: string;
  title: string;
  message?: string | null;
  type?: AppNotificationType | null;
};

export type AppNotificationFeedProps = {
  notifications: AppNotificationFeedItem[];
  onDismiss: (id: string) => void;
};

export function AppNotificationFeed({ notifications, onDismiss }: AppNotificationFeedProps) {
  return (
    <ul className="fixed top-4 right-4 z-2147483003 w-full max-w-sm">
      {notifications.map((notification) => (
        <li key={notification.id} className="mb-2">
          <AppNotification
            title={notification.title}
            message={notification.message}
            type={notification.type}
            onDismiss={() => onDismiss(notification.id)}
          />
        </li>
      ))}
    </ul>
  );
}
